/**
 * @desc 更新报损凭证附件
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.StorageMasterUrlUpdateDto, options?: any) {
  return updateResponse(
    http(URL + `/storageDamageMaster/updateCertificateFileUrl`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
